<template>
    <div class="d-flex flex-column w-100">
        <navBar/>
		<banner titulo="CAT" subTitulo="Comunicação de Acidente de Trabalho"/>
		<div class="borda w-75 mx-auto p-3 gap-sm d-flex flex-column alinhamento-start">
			<div>
				<b-button v-if="!mostrarFormularioCat" variant="dark" @click="abreFormularioCat(0)">Formulário CAT</b-button>
				<b-button v-else variant="secondary" @click="fechaFormularioCat()">Voltar</b-button>
			</div>
			<formularioCat v-if="mostrarFormularioCat" :idCat="idCatFormularioCat" @sucesso="handleCatEnviadoComSucesso"/>
			<tableCatJaEnviadoPorUsuario @visualizarCat="handleVisualizarCat($event)" v-else/>
		</div>
    </div>
</template>

<script>
import Banner from "../../components/shared/Banner.vue";
import NavBar from "../../components/shared/NavBar.vue";
import FormularioCat from "../../components/Cat/FormularioCat.vue";
import TableCatJaEnviadoPorUsuario from "../../components/Cat/TableCatJaEnviadoPorUsuario.vue";

export default{
	name: "Cat",
	components: {
		banner: Banner,
		navBar: NavBar,
		formularioCat: FormularioCat,
		tableCatJaEnviadoPorUsuario: TableCatJaEnviadoPorUsuario,
	},
	data() {
		return {
			mostrarFormularioCat: false,
			idCatFormularioCat: 0,
		};
	},
	created() {
	},
	methods: {
		handleCatEnviadoComSucesso() {
			this.mostrarFormularioCat = false;
			this.idCatFormularioCat = 0;
		},
		handleVisualizarCat(idCat) {
			this.abreFormularioCat(idCat);
		},
		abreFormularioCat(idCat) {
			if (idCat != 0) {
				this.idCatFormularioCat = idCat;
				this.mostrarFormularioCat = true;
			} else {
				this.mostrarFormularioCat = true;
			}
		},
		fechaFormularioCat() {
			this.mostrarFormularioCat = false;
			this.idCatFormularioCat = 0;
		},
		mensagem(msg, titulo, variant) {
			this.$bvToast.toast(msg, {
				title: titulo,
				autoHideDelay: 6000,
				appendToast: true,
				variant,
				toaster: "b-toaster-bottom-right",
			});
		},
	},
};
</script>
<style scoped>
.alinhamento-start{
	justify-content: flex-start !important;
}

</style>



// WEBPACK FOOTER //
// src/views/cat/Cat.vue